<template>
  <v-card class="mb-2" rounded="lg">
    <v-card-title class="title--dark py-2">
      <div class="sido_name white--text">{{ sido.sidoName }}</div>
      <div class="total_count">{{ sido.siguName }}</div>
      <v-spacer></v-spacer>
      <div style="width: 38px;height: 28px">
        <v-img height="28" width="36" :src="getIconSrc()"></v-img>
      </div>
    </v-card-title>
    <v-card-text class="pa-0">
      <v-container fluid>
        <v-row>
          <v-col class="pb-0" cols="6">
            <gauge-chart
              title="발전량"
              unit="KW"
              :max="sido.totalCapacity * 1.1"
              :value="sido.pvpcsPac"
              color="#90F072"
              :flag="flag"
            ></gauge-chart>
          </v-col>
          <v-col class="pb-0" cols="6">
            <gauge-chart
              title="당일 발전량"
              unit="MWH"
              :max="(sido.totalCapacity * 8 * 1.1)/1000"
              :value="sido.pvpcsDailyP/1000"
              color="#04B8FF"
              :flag="flag"
            ></gauge-chart>
          </v-col>
          <v-col cols="12" class="text-center py-0">
            <span
              class="site-card-time"
            >{{ sido.dailyTime ? sido.dailyTime.toFixed(1) : sido.dailyTime }}</span>
            hr
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
    <v-expand-transition>
      <v-card style="background-color:#303B56" class="ma-2" v-show="show">
        <v-simple-table fixed-header height="150px" dense style="min-width: 270px;">
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-center"></th>
                <th class="text-center"></th>
                <th class="text-center fontSize-7rem" style="color: #90F072">발전량</th>
                <th class="text-center fontSize-7rem" style="color: #04B8FF">
                  당일
                  <p class="mb-0">발전량</p>
                </th>
                <th class="text-center fontSize-7rem" style="color: #FFA837">총용량</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(sigu, index) in siguList"
                :key="index"
                @click="goPersonalMonitoring(index)"
                style="cursor: pointer;"
              >
                <td class="text-left px-1">
                  <v-img height="26" width="28" :src="getSiteStatusIconSrc(sigu.run_status)"></v-img>
                </td>

                <td class="text-left px-0">
                  <v-tooltip bottom>
                    <template v-slot:activator="{on,attrs}">
                      <div :class="setSiteClass" v-bind="attrs" v-on="on">{{ sigu.DESCRIPTION }}</div>
                    </template>
                    <span>{{sigu.DESCRIPTION}}</span>
                  </v-tooltip>
                </td>

                <td class="text-center px-0 py-1">
                  <v-chip
                    label
                    small
                    outlined
                    class="px-1"
                    style="border-color:#90F072;background-color: rgba(170,251,159,0.5) !important;"
                  >
                    <div
                      class="overflow-hidden"
                      style="width: 35px; text-overflow: ellipsis"
                    >{{ sigu.PVPCS_Pac ? sigu.PVPCS_Pac.toFixed(0) : sigu.PVPCS_Pac }}</div>
                  </v-chip>
                </td>
                <td class="text-center px-0">
                  <v-chip
                    label
                    small
                    outlined
                    class="px-1"
                    style="border-color:#04B8FF;background-color: rgba(4,184,225,0.5) !important;"
                  >
                    <div class="overflow-hidden" style="width: 35px; text-overflow: ellipsis">
                      <span>{{ sigu.PVPCS_Daily_P ? sigu.PVPCS_Daily_P.toFixed(0) : sigu.PVPCS_Daily_P }}</span>
                    </div>
                  </v-chip>
                </td>
                <td class="text-center px-0">
                  <v-chip
                    label
                    small
                    outlined
                    class="px-1"
                    style="border-color:#FFA837;background-color: rgba(255,168,55,0.5) !important;"
                  >
                    <div
                      class="overflow-hidden"
                      style="width: 35px; text-overflow: ellipsis"
                    >{{ sigu.totalCapacity }}</div>
                  </v-chip>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card>
    </v-expand-transition>
    <v-card-actions class="pa-0">
      <v-spacer></v-spacer>
      <v-btn icon @click="show = !show">
        <v-icon>{{ show ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
    </v-card-actions>
  </v-card>
</template>

<script>
import GaugeChart from '@/components/monitoring/GaugeChart'
export default {
  name: 'ExpansionGaugeCard',
  components: {
    GaugeChart
  },
  data() {
    return {
      show: false,
      value: 0
    }
  },
  props: {
    title: {
      type: String
    },
    sido: {
      type: Object,
      default: () => {
        return {
          totalCapacity: 0,
          totalCount: 0,
          runCount: 0,
          faultCount: 0,
          pauseCount: 0,
          errorCount: 0,
          pvpcsPac: 0,
          pvpcsDailyP: 0,
          dailyTime: 0,
          expectPrice: 0,
          sidoCode: null,
          sidoName: null,
          siguCode: null,
          siguName: null,
          faultList: [],
          errorList: []
        }
      }
    },
    siguList: Array,
    flag: {
      type: Number,
      default: 0
    },
    sidoTotal: {
      type: Number,
      default: 0
    }
  },
  computed: {
    imageShow() {
      if (this.sido.faultCount > 0 || this.sido.errorCount > 0) {
        return true
      } else {
        return false
      }
    },
    setSiteClass() {
      if (this.$vuetify.breakpoint.mdAndUp) {
        return 'site-title'
      }
      return ''
    }
  },
  watch: {},
  mounted() {
    if (this.sidoTotal <= 5) {
      console.log(this.sidoTotal)
      this.show = true
    }
  },
  methods: {
    getIconSrc() {
      if (this.sido.faultCount > 0) {
        return require('@/assets/image/monitoring/icon_alert01.png')
      } else if (this.sido.errorCount > 0) {
        return require('@/assets/image/monitoring/icon_alert02.png')
      } else {
        return ''
      }
    },
    getSiteStatusIconSrc(status) {
      if (status === 'Fault') {
        return require('@/assets/image/monitoring/icon_alert01.png')
      } else if (status === 'Pause') {
        return require('@/assets/image/monitoring/icon_alert02.png')
      } else {
        return ''
      }
    },
    goPersonalMonitoring(i) {
      let siteId = this.siguList[i].SITE_ID
      console.log(siteId, siteId.indexOf('E'))
      if (siteId.indexOf('E') >= 0) {
        this.$router.push({
          name: 'essSiteWork',
          query: { site_id: siteId }
        })
      } else {
        this.$router.push({
          name: 'siteWork',
          query: { site_id: siteId }
        })
      }
    }
  }
}
</script>

<style scoped>
.sido_name {
  width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.total_count {
  font-size: 16px;
  color: #999;
}
.fontSize-7rem {
  font-size: 0.78rem !important;
}
.site-title {
  width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
